import React from 'react';
import classNames from 'classnames';

import {
	FaInstagram,
	FaFacebook,
	FaYoutube,
	FaTwitter,
	FaLinkedin
} from 'react-icons/fa';

import Link from '../Link';

const ns = `social-icons`;

const renderSocialIcon = url => {
	const domain = url
		.replace(/.+\/\/|www.|\..+/g, '')
		.toLowerCase();

	switch (domain) {
	case 'facebook':
		return <FaFacebook size={30} />;
	case 'instagram':
		return <FaInstagram size={30} />;
	case 'twitter':
		return <FaTwitter size={30} />;
	case 'youtube':
		return <FaYoutube size={40} />;
	case 'linkedin':
		return <FaLinkedin size={30} />;
	default:
		return <></>;
	}
};

const SocialIcons = ({ items = [] }) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	if (items.length <= 0) return null;

	return (
		<ul className={rootClassnames}>
			{items.map(({ link }) => {
				const {
					label,
					url,
				} = link;

				return (
					<li key={url}>
						<Link href={url}>
							{label !== null && (
								<span className={`visually-hidden`}>{ label }</span>
							)}
							{renderSocialIcon(url)}
						</Link>
					</li>
				);
			})}
		</ul>
	);
};

export default SocialIcons;
